import { AxiosInstance } from "axios";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { IUserSecurityDto, IBaseUserDto, IUserSecurityOfficerDto } from "../interfaces/AdminInterfaces";

enum UserAuthServiceEnum {
  getPortalUser = "user",
  getOfficerUser = "officer/user/security",
  getAdminUser = "admin/user/security",
  getBaseUser = "user"
}

export class UserAuthService {
  protected restClient: AxiosInstance;
  constructor(restClient: AxiosInstance) {
    this.restClient = restClient;
  }
  public getPortalUser = async () => await this.GET(UserAuthServiceEnum.getPortalUser);
  public getOfficer = async (token: string): Promise<IUserSecurityOfficerDto> => await this.GET(UserAuthServiceEnum.getOfficerUser, token);
  public getAdminUser = async (token: string): Promise<IUserSecurityDto> => await this.GET(UserAuthServiceEnum.getAdminUser, token);
  public getBaseUser = async (): Promise<IBaseUserDto> => await this.GET(UserAuthServiceEnum.getBaseUser);

  private async GET(url, captchaToken = null, errorMessage = null, responseType = null) {
    try {
      const response = (
        await this.restClient.get(url, {
          responseType: responseType ? responseType : "json",
          headers: {
            "captcha": captchaToken
          }
        })
      ).data;
      return response;
    } catch (error) {
      return this.handleError(error, errorMessage);
    }
  }

  private handleError(error, errorMessage = null) {
    if (errorMessage) {
      ShowNotification.Error(errorMessage.Message, errorMessage.Description);

      throw error;
    }
    ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante a consulta. Tente novamente.");
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/services/api/UserAuth.service.ts